import type { Navigation, NavigationItem, Nullable } from '@boss/types/corporate-jobs';
import { icons } from '@boss/ui';
import { getLink, getValuable } from '@boss/utils';

import { INavigation, INavigationItem } from '../../utils/navigation/types';

const getUrl = (navItem: INavigationItem, locale: string) => {
  if (navItem.internalPageLink) {
    const pagePath = getLink(navItem.internalPageLink, locale);
    const anchor = navItem.internalPageLink.anchor ? `#${navItem.internalPageLink.anchor}` : '';

    return `${pagePath}${anchor}`;
  }

  if (navItem.externalLink) {
    return navItem.externalLink;
  }

  return null;
};

const mapNavLinks = (links: Nullable<INavigationItem[]>, locale: string): Nullable<NavigationItem[]> =>
  links?.map(link => {
    const iconName = link.icon ?? link.internalPageLink?.icon;
    const label = link.label ?? link.internalPageLink?.label;

    return getValuable({
      href: getUrl(link, locale),
      icon: iconName && icons.getPreloadedIcon(iconName),
      label: label,
      id: link.id,
      image: link.image,
      childNavigationItems: mapNavLinks(link.childNavigationItems, locale),
      highlightedChildNavigationItems: mapNavLinks(link.highlightedChildNavigationItems, locale),
    });
  });

const getNavigationProps = (navigation: INavigation, locale: string): Navigation =>
  getValuable({
    id: navigation.id,
    channel: navigation.channel,
    footerNavigationItems: mapNavLinks(navigation.footerNavigationItems, locale),
    footerJobsHashtag: navigation.footerJobsHashtag,
    headerLogo: navigation.headerLogo,
    footerLogo: navigation.footerLogo,
    headerNavigationItems: mapNavLinks(navigation.headerNavigationItems, locale),
    highlightedCta: mapNavLinks(navigation.highlightedCta, locale),
    legalLinks: mapNavLinks(navigation.legalLinks, locale),
    secondaryCtas: mapNavLinks(navigation.secondaryCtas, locale),
    socialLinks: mapNavLinks(navigation.socialLinks, locale),
  });

export default getNavigationProps;
